import { createContext, useContext, useState } from "react";
import type { AnalysisAgentContextType } from "./AnalysisAgentContextType";
import { ALL_BATCHES } from "../../../../entities/entities";
import type { ParentRowExamplesParamsType, ParentRowSourceValuesParamsType } from "../AnalysisAgentType";

const AnalysisAgentContext = createContext<
  AnalysisAgentContextType | undefined
>(undefined);

export const useAnalysisAgentContext = () => {
  const context = useContext(AnalysisAgentContext);

  if (!context)
    throw new Error(
      "useAnalysisAgentContext must be used inside useAnalysisAgentProvider",
    );
  return context;
};

export const AnalysisAgentProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [deferredActionsData, setDeferredActionsData] = useState([]);
  const [parentRowExamplesParams, setParentRowExamplesParams] =
    useState<ParentRowExamplesParamsType>({
      targetTable: null,
      hash: null,
    });
  const [parentRowSourceValuesParams, setParentRowSourceValuesParams] =
    useState<ParentRowSourceValuesParamsType>({
      targetTable: null,
      hash: null,
      state: null
    });
  const [tableSort, setTableSort] = useState(null);
  const [filtersForStatus, setFiltersForStatus] = useState();
  const [attributeToAnalyze, setAttributeToAnalyze] = useState<string | null>(
    null,
  );
  const [selectedBatches, setSelectedBatches] = useState<string[]>([
    ALL_BATCHES[0].key,
  ]);
  const [activeBatch, setActiveBatch] = useState("");

  return (
    <AnalysisAgentContext.Provider
      value={{
        deferredActionsData,
        setDeferredActionsData,
        parentRowExamplesParams,
        setParentRowExamplesParams,
        parentRowSourceValuesParams,
        setParentRowSourceValuesParams,
        tableSort,
        setTableSort,
        filtersForStatus,
        setFiltersForStatus,
        attributeToAnalyze,
        setAttributeToAnalyze,
        selectedBatches,
        setSelectedBatches,
        activeBatch,
        setActiveBatch
      }}
    >
      {children}
    </AnalysisAgentContext.Provider>
  );
};
